<script setup lang="ts">
defineProps<{
  as: "div" | "button" | "a";
  count?: number;
  label?: string;
}>();
defineSlots<{
  default(): void;
  count(): void;
}>();
</script>

<template>
  <Component :is="as" class="group relative flex flex-col items-center justify-center gap-2">
    <div class="btn-scale-sm lg:btn-scale-md">
      <slot />
    </div>
    <div v-if="count" class="absolute -right-1.5 top-8 flex min-w-5 justify-center rounded-full border-2 border-primary bg-white px-1 text-xs font-bold text-primary lg:right-1 lg:top-12">
      <slot name="count">
        {{ count }}
      </slot>
    </div>
    <div v-if="label" class="hidden text-center text-sm font-medium text-primary xl:block">
      {{ label }}
    </div>
  </Component>
</template>
